"use client";
import * as React from "react";
const SvgVisibilityOnOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 1.995a7.106 7.106 0 0 1 6.415 4c-1.2 2.45-3.659 4-6.415 4a7.106 7.106 0 0 1-6.415-4c1.2-2.451 3.659-4 6.415-4ZM8 .54c-3.636 0-6.742 2.262-8 5.455 1.258 3.192 4.364 5.454 8 5.454s6.742-2.262 8-5.454C14.742 2.802 11.636.54 8 .54Zm0 3.636a1.819 1.819 0 1 1-.001 3.638A1.819 1.819 0 0 1 8 4.176Zm0-1.454a3.278 3.278 0 0 0-3.273 3.273A3.278 3.278 0 0 0 8 9.267a3.278 3.278 0 0 0 3.273-3.272A3.278 3.278 0 0 0 8 2.722Z" }));
export {
  SvgVisibilityOnOutlined as default
};
